import script from "./OrderTimelinePage.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderTimelinePage.vue?vue&type=script&setup=true&lang=js"

import "./OrderTimelinePage.vue?vue&type=style&index=0&id=9e45c832&scoped=true&lang=css"

import exportComponent from "/home/marco/docker-devs/laundryrepublic/codebase/lr-epos2-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9e45c832"]])

export default __exports__